export default __webpack_public_path__ + "static/media/osrcr06_1.5980565a.png";